"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const react_1 = __importDefault(require("react"));
require("./index.scss");
const common_1 = require("@App/const/common");
const MatchRoad = ({ step }) => (react_1.default.createElement("div", { className: `match-road step-${step}` },
    react_1.default.createElement("div", { className: "progress-item" },
        react_1.default.createElement("img", { className: "work-icon", src: common_1.ICONS.workDetails }),
        react_1.default.createElement("p", null, "Choose Work")),
    react_1.default.createElement("div", { className: "progress-item" },
        react_1.default.createElement("img", { className: "review-icon", src: common_1.ICONS.review }),
        react_1.default.createElement("p", null, "Review & Submit"))));
exports.default = MatchRoad;
